import React, { Component } from 'react';
import { getTranslation } from '../../assets/creator/translations';
import { formatString } from '../../utils/string/string';


class InputInteger extends Component {
    integerRegex = /^(-?([1-9]\d*?|0))$/;
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            isValid: true,
            isIntegerLike: true,
            isWithinConstraints: true
        }
        if (props.minValue || props.minValue === 0) {
            this.minValue = props.minValue;
        } else {
            this.minValue = Number.MIN_SAFE_INTEGER;
        }
        this.maxValue = props.maxValue || Number.MAX_SAFE_INTEGER;
        this.className = props.className || "options";
    }


    isIntegerLike = (stringValue) => (this.integerRegex.test(stringValue))
    isWithinValueConstraint = (intValue) => (intValue >= this.minValue && intValue <= this.maxValue);
    validate = (intValue) => (!isNaN(intValue) && this.isWithinValueConstraint(intValue));

    handleChange = (e) => {
        let inputNewValue = e.target.value;
        const validSigns = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
        for (const inputVal of inputNewValue) {
            if(!(validSigns.includes(inputVal))) {
                inputNewValue = inputNewValue.replace(inputVal,'');
            }
        }
        const newValue = inputNewValue;
        const newValueInt = parseInt(newValue, 10);

        const isValid = this.isIntegerLike(newValue) && this.validate(newValueInt);
        const newStateValue = newValue;
        this.setState({
            isValid: isValid,
            isIntegerLike: this.isIntegerLike(newValue),
            isWithinConstraints: this.isWithinValueConstraint(newValueInt),

            value: newStateValue,
        });
        this.sendResponse(isValid, newValueInt);
    }

    sendResponse = (isValid, intValue) => {
        let valueToSend = null;
        if (isValid) {
            valueToSend = intValue;
        }
        if (typeof this.props.onChange === "function") {
            this.props.onChange(valueToSend);
        }

    }

    

    error = () => (
        !this.state.isValid && (
            (this.notIntegerLikeError() ) || ( this.notWithinConstaintsError() )
        )

    )
    notIntegerLikeError = () => (
        !this.state.isIntegerLike &&
            <p className={`${this.className}__error`}>
                {getTranslation("InputValidationErrorNumericValue")}
            </p>
    )

    notWithinConstaintsError = () => (
        !this.state.isWithinConstraints &&
        <p className={`${this.className}__error`}>
            {formatString(getTranslation("InputValidationErrorNotWithinConstaints"), this.minValue, this.maxValue)}
        </p>
    )

    render = () => {
        let inputStyle = null;
        if (!this.state.isValid) {
            inputStyle = {border: "solid 1px red"};
        }
        return (
            <React.Fragment>
                <input
                    onChange={this.handleChange}
                    className={`${this.className}__input`}
                    type="text"
                    value={this.state.value}
                    style={inputStyle}
                />
                {this.error()}
            </React.Fragment>
        );
    }

    
}

export default InputInteger